;(() => {
  'use strict'
  const NewsletterPopin = class extends HTMLElement {
    constructor() {
      super()
      this.style.display = null
    }

    connectedCallback() {
      this.section.addEventListener('click', (event) => {
        if (event.target === this.section) {
          this.hide()
        }
      })

      this.closeButton.addEventListener('click', () => {
        this.hide()
      })
      this.checkAndShow()
    }

    get section() {
      const section = this.closest('.shopify-section')
      if (!section) {
        console.warn('No parent section found for:', this)
      }

      return section
    }

    get closeButton() {
      return this.querySelector('.popin-close')
    }

    get form() {
      return this.querySelector('form')
    }

    get emailInput() {
      return this.querySelector("input[type='email']")
    }

    get emailErrorElement() {
      return this.querySelector('.form-error')
    }

    get confidentialityCheckbox() {
      return this.querySelector("input[type='checkbox']")
    }

    get submitButton() {
      return this.querySelector("button[type='submit']")
    }

    get appearanceDelay() {
      return parseInt(this.dataset.appearanceDelay, 10) || 0
    }

    checkAndShow = () => {
      if (
        window.location.hash === `#${this.form.id}` ||
        window.location.search.includes(`show_newsletter_popin`)
      ) {
        this.show()
        window.localStorage.setItem('showNewsletterPopin', 'false')
        return
      }

      const showPopin = window.localStorage.getItem('showNewsletterPopin')
      if (showPopin === 'false') {
        return
      }

      const productVisited = window.localStorage.getItem(
        'newsletterPopinProductVisited'
      )
      const productHandleList = productVisited ? productVisited.split(',') : []

      const productVisitedCount = Array.from(productHandleList)

      if (productVisitedCount.length < 2) {
        const isProductPage = window.location.pathname.includes('/products/')
        if (!isProductPage) return

        const productHandle = window.location.pathname.split('/products/')[1]
        if (productHandleList.includes(productHandle)) return

        productHandleList.push(productHandle)
        window.localStorage.setItem(
          'newsletterPopinProductVisited',
          productHandleList.join(',')
        )

        if (productHandleList.length < 2) return
      }

      const delay = parseInt(this.appearanceDelay)
      if (delay === 0) {
        window.localStorage.setItem('showNewsletterPopin', 'false')
        return
      }

      setTimeout(() => {
        this.show()
        window.localStorage.setItem('showNewsletterPopin', 'false')
      }, delay * 1000)
    }

    isEmailValid = () => {
      const basicValidity = this.emailInput.checkValidity()
      if (!basicValidity) {
        return false
      }
      if (this.emailInput.value === '') {
        return true
      }
      const emailRegex =
        /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/
      return emailRegex.test(this.emailInput.value)
    }

    onSubmitButtonClick = (event) => {
      event.preventDefault()

      this.hideErrors()

      const isEmailValid = this.isEmailValid()
      const isCheckboxChecked = this.confidentialityCheckbox.checked

      if (!isEmailValid) {
        this.showEmailError()
      }

      if (!isCheckboxChecked) {
        this.showCheckboxError()
      }

      if (isEmailValid && isCheckboxChecked) {
        this.form.submit()
        return true
      }

      return false
    }

    onFormSubmit = (event) => {
      event.preventDefault()
      this.submitButton.click()
    }

    onEmailInput = () => {
      if (this.emailErrorElement) {
        this.emailErrorElement.setAttribute('aria-hidden', this.isEmailValid())
      }
    }

    onCheckboxChange = () => {
      if (
        this.confidentialityCheckbox.checked &&
        this.confidentialityCheckbox
      ) {
        this.confidentialityCheckbox.setAttribute('aria-invalid', 'false')
      }
    }

    getFocusableElements = () => {
      return Array.from(
        this.querySelectorAll(
          'button:not([disabled]), [href], input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )
      ).filter((el) => el.offsetWidth > 0 || el.offsetHeight > 0)
    }

    onKeydown = (event) => {
      if (event.key === 'Escape') {
        this.hide()
        return
      }
      if (event.key === 'Tab') {
        const focusable = this.getFocusableElements()
        if (focusable.length === 0) return
        const first = focusable[0]
        const last = focusable[focusable.length - 1]
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault()
          last.focus()
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault()
          first.focus()
        }
      }
    }

    show = () => {
      this.lastFocusedElement = document.activeElement
      this.setAttribute('data-open', '')
      document.documentElement.classList.add('is-overflow-hidden')
      this.addEventListener('keydown', this.onKeydown)
      // Déplacer le focus dans la modale (bouton de fermeture en priorité).
      const focusTarget = this.closeButton || this.getFocusableElements()[0]
      focusTarget?.focus()
    }

    hide = () => {
      this.removeAttribute('data-open', '')
      document.documentElement.classList.remove('is-overflow-hidden')
      this.removeEventListener('keydown', this.onKeydown)
      // Restaurer le focus sur l'élément déclencheur.
      if (this.lastFocusedElement && this.lastFocusedElement.focus) {
        this.lastFocusedElement.focus()
      }
    }

    showEmailError = () => {
      if (this.emailErrorElement) {
        this.emailErrorElement.setAttribute('aria-hidden', 'false')
      }
    }

    showCheckboxError = () => {
      if (this.confidentialityCheckbox) {
        this.confidentialityCheckbox.parentElement.setAttribute(
          'aria-invalid',
          'true'
        )
      }
    }

    hideErrors = () => {
      if (this.emailErrorElement) {
        this.emailErrorElement.setAttribute('aria-hidden', 'true')
      }
      if (this.confidentialityCheckbox) {
        this.confidentialityCheckbox.parentElement.setAttribute(
          'aria-invalid',
          'false'
        )
      }
    }
  }
  if (!window.customElements.get('newsletter-popin')) {
    window.customElements.define('newsletter-popin', NewsletterPopin)
  }
})()